// @ts-expect-error TS(2339): Property 'toCamelCase' does not exist on type 'Str... Remove this comment to see the full error message

String.prototype.toCamelCase = function toCamelCase() {
  return this.valueOf()
    .replace(/\s(.)/g, ($1) => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, ($1) => $1.toLowerCase());
};
